import React, { useState } from 'react';
import { Spinner, UploadSimple } from '@phosphor-icons/react';
import { dropzoneClass } from './constants';

const UploadDropzone = ({ uploading, uploadStatus, onFiles }) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => setIsDragging(false);
  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (uploading) return;
    const files = Array.from(e.dataTransfer.files || []);
    if (files.length > 0) onFiles(files);
  };
  const handleFileInput = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) onFiles(files);
    e.target.value = '';
  };

  return (
    <div
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      className={`relative border-2 border-dashed rounded-xl transition-colors ${dropzoneClass(uploading, isDragging)}`}
      data-testid="upload-dropzone"
    >
      <label
        className={`block cursor-pointer p-8 text-center ${uploading ? 'cursor-wait' : ''}`}
      >
        <input
          type="file"
          accept=".pdf,.png,.jpg,.jpeg,.webp,.heic,.heif,image/heic,image/heif"
          multiple
          onChange={handleFileInput}
          disabled={uploading}
          className="hidden"
          data-testid="upload-file-input"
        />
        {uploading ? (
          <div className="flex flex-col items-center gap-3">
            <div className="w-14 h-14 bg-indigo-100 rounded-full flex items-center justify-center">
              <Spinner size={28} className="text-indigo-700 animate-spin" />
            </div>
            <div>
              <p className="text-base font-semibold text-indigo-900">
                AI is scanning your timesheets…
              </p>
              <p className="text-sm text-indigo-600 mt-1">
                {uploadStatus || 'Reading handwriting, splitting PDFs, matching records'}
              </p>
            </div>
            <div className="w-64 h-1.5 bg-indigo-100 rounded-full overflow-hidden">
              <div className="h-full bg-indigo-600 rounded-full animate-pulse w-3/5" />
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-3">
            <div className="w-14 h-14 bg-indigo-100 rounded-full flex items-center justify-center">
              <UploadSimple size={28} className="text-indigo-700" weight="bold" />
            </div>
            <div>
              <p className="text-base font-semibold text-slate-900">
                Drop timesheets here or{' '}
                <span className="text-indigo-700 underline">browse</span>
              </p>
              <p className="text-sm text-slate-500 mt-1">
                PDF, PNG, JPEG, or WEBP · Drop as many as you like · Multi-page PDFs auto-split
              </p>
            </div>
          </div>
        )}
      </label>
    </div>
  );
};

export default UploadDropzone;
